<div class="modal-header">
  <h4 class="modal-title"> {{ 'save.confirm.popup.title' | translate }} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    @if (isWriteProtected) {
      <p>{{ 'save.confirm.label.currentVersionIsBlocked' | translate }}</p>
    }
    <p>{{ 'save.confirm.label.pleaseChooseSaveType' | translate }}</p>
    <div class="ps-5">
      @if (saveAsNewVersion) {
        <div class="form-check mb-2">
          <input class="form-check-input" type="radio" name="gridRadios" id="saveAsNewVersion"
                 [(ngModel)]="checkedType" [value]="closeTypes.SAVE_AS_NEW_VERSION">
          <label class="form-check-label" for="saveAsNewVersion">{{ 'save.confirm.button.saveAsNewVersion' | translate }}</label>
        </div>
      }
      @if (showSaveAsNewProject) {
        <div class="form-check mb-2">
          <input class="form-check-input" type="radio" name="gridRadios" id="saveAsNewProject"
                 [(ngModel)]="checkedType" [value]="closeTypes.SAVE_AS_NEW_PROJECT">
          <label class="form-check-label" for="saveAsNewProject">{{ 'save.confirm.button.saveAsNewProject' | translate }}</label>
        </div>
      }
      @if (saveAsXCOM) {
        <div class="form-check mb-2">
          <input class="form-check-input" type="radio" name="gridRadios" id="saveAndSplit"
                 [(ngModel)]="checkedType" [value]="closeTypes.SAVE_AND_SPLIT">
          <label class="form-check-label" for="saveAndSplit">{{ 'save.confirm.button.saveAndSplit' | translate }}</label>
        </div>
      }
      @if (overwriteProject) {
        <div class="form-check mb-2">
          <input class="form-check-input" type="radio" name="gridRadios" id="overwriteProject"
                 [(ngModel)]="checkedType" [value]="closeTypes.OVERWRITE_PROJECT">
          <label class="form-check-label" for="overwriteProject">{{ 'save.confirm.button.overwriteProject' | translate }}</label>
        </div>
      }
      @if (overwriteAnyVersion) {
        <div class="form-check mb-2">
          <input class="form-check-input" type="radio" name="gridRadios" id="overwriteVersion"
                 [(ngModel)]="checkedType" [value]="closeTypes.OVERWRITE_ANY_VERSION">
          <label class="form-check-label" for="overwriteVersion">{{ 'save.confirm.button.overwriteVersion' | translate }}</label>
        </div>
      }
      <hr>
      @if (noticeText()) {
        <p>{{ noticeText() | translate }}</p>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close(-1)">{{ 'global.label.cancel' | translate }}</button>
  <button type="button" class="btn btn-primary btn-forward" id="step_forward" (click)="saveButtonClickHandler()" [disabled]="!checkedType()">
    {{ 'global.label.ok' | translate }}
  </button>
</div>
